module.exports = __webpack_public_path__ + "static/media/JD.aa51efb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/JD.jpg
// module id = 376
// module chunks = 0